var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89386 3.80619C10.2155 5.12786 10.2155 7.27284 8.89386 8.59451C7.57219 9.91617 5.42717 9.91617 4.10551 8.59451C2.78384 7.27284 2.78384 5.12786 4.10551 3.80619C5.42717 2.48452 7.57219 2.48452 8.89386 3.80619Z",
    stroke: "#007AFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46863 11.2217C3.38529 10.7884 2.43737 10.003 1.80904 8.91423C1.19154 7.84714 0.985706 6.66089 1.13196 5.52881",
    stroke: "#007AFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16846 1.92665C4.08929 1.20623 5.24304 0.77832 6.4997 0.77832C7.72929 0.77832 8.86137 1.1954 9.77137 1.88873",
    stroke: "#007AFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 11.2217C9.61458 10.7884 10.5625 10.003 11.1908 8.91423C11.8083 7.84714 12.0142 6.66089 11.8679 5.52881",
    stroke: "#007AFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2);
export default __webpack_public_path__ + "static/media/circle-2.fc5f2ff3a45cecdf1ba2896d23ab2b9a.svg";
export { ForwardRef as ReactComponent };